import {
    CREATE_USER,
    CREATE_USER_FAILURE,
    CREATE_USER_SUCCESS,
} from 'store/actions/types';

export const createUser = (payload) => {
    return {
        type: CREATE_USER,
        payload: payload,
    };
};

export const createUserFailure = (error) => {
    return {
        type: CREATE_USER_FAILURE,
        error: error,
    };
};

export const createUserSuccess = (response) => {
    return {
        type: CREATE_USER_SUCCESS,
        response: response,
    };
};



// WEBPACK FOOTER //
// ./src/store/actions/users/createUsers.js